/**
 * pdf.js, loaded on first use and shared — the Getting Started carousel and
 * post PDF previews both draw with it.
 *
 * THE LEGACY BUILD OF pdf.js, ON PURPOSE. The default build targets only the
 * newest browsers; the legacy one is transpiled and polyfilled, so the preview
 * works on older Safari and Firefox ESR too. Both the library and its worker
 * are loaded on first use, so nobody downloads them who never opens the modal.
 *
 * THE WORKER GOES THROUGH VITE'S `new Worker(new URL(...))`, not `?url`. The
 * `?url` route ships pdf.js's file as `.mjs`, and a worker only runs when it is
 * served with a JavaScript MIME type — which the S3 sync in our deploy does not
 * guarantee for `.mjs`. Vite bundles this form as a classic `.js` worker, which
 * every host serves correctly and every browser can start. One worker is
 * shared by every document, as `workerPort` intends.
 */

let worker: Worker | null = null;

export const loadPdfjs = async () => {
  const pdfjs = await import("pdfjs-dist/legacy/build/pdf.mjs");
  if (!worker) {
    worker = new Worker(new URL("pdfjs-dist/legacy/build/pdf.worker.min.mjs", import.meta.url), {
      type: "module",
    });
    pdfjs.GlobalWorkerOptions.workerPort = worker;
  }
  return pdfjs;
};
